let initialState = {
  brands: null,
  duration: null,
  chat_with_data_res: {
    persist_data: [],
    data: [],
    total_length: null,
  },
  chats_answer_loader: false,
  topic_answer_loader: false,
  topic_answer_on_scroll_loader: false,
  chat_topics_history: {
    persist_data: [],
    data: [],
    total_length: null,
  },
  chat_history_loader: false,
  starter_questions: [],
  trending_suggestions_list: [],
  starter_questions_loader: false,
  trending_suggestions_loader: false,
  selected_chat_data: null,
  brand_changed: false,
  duration_changed: false,
  otp_status_flag: false,
  sign_up_loader: false,
  otp_validate_loader: false,
  user_profile_details: null,
  user_profile_save_loader: false,
  user_profile_modal_flag: false,
  get_visitor_id_loader: false,
  payment_process_loader: false,
  follow_up_questions_list: [],
  follow_up_questions_loader: false,
  credits_count_loader: false,
  plans_list: [],
  plans_list_loader: false,
  cancel_subscription_loader: false,
  delete_account_loader: false,
  sign_in_through_flag: false,
  landing_page_questions_list: [],
  credit_limit_exhausted: false,
  delete_account_reason_list: [],
  auth_loader: false,
  negative_feedback_reason_list: [],
  global_search_chat_list: [],
  global_search_chat_loader: false,
  shareableLink: null,
  chats_stream_loader: false,
  sign_up_failed_flag: {
    flag: false,
    message: null,
  },
  chart_artifact_loader: false,
  show_blurred_background: false,
  persona: "cmo",
};

const ChatWithData = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_SCREEN":
      return {
        ...initialState,
      };
    case "SET_BRANDS_IN_CHAT_WITH_DATA":
      return {
        ...state,
        brands: action.value,
      };
    case "SET_DURATION_IN_CHAT_WITH_DATA":
      return {
        ...state,
        duration: action.value,
      };
    case "SET_CHAT_WITH_DATA_RESPONSE":
      return {
        ...state,
        chat_with_data_res: action.value,
      };
    case "SET_CHATS_ANSWER_LOADER":
      return {
        ...state,
        chats_answer_loader: action.value,
      };
    case "SET_TOPIC_ANSWER_LOADER":
      return {
        ...state,
        topic_answer_loader: action.value,
      };
    case "SET_TOPIC_ANSWER_ON_SCROLL_LOADER":
      return {
        ...state,
        topic_answer_on_scroll_loader: action.value,
      };
    case "SET_CHAT_TOPICS_HISTORY":
      return {
        ...state,
        chat_topics_history: action.value,
      };
    case "SET_CHATS_HISTORY_LOADER":
      return {
        ...state,
        chat_history_loader: action.value,
      };
    case "SET_STARTER_QUESTIONS":
      return {
        ...state,
        starter_questions: action.value,
      };
    case "SET_TRENDING_SUGGESTIONS_LIST":
      return {
        ...state,
        trending_suggestions_list: action.value,
      };
    case "SET_STARTER_QUESTIONS_LOADER":
      return {
        ...state,
        starter_questions_loader: action.value,
      };
    case "SET_TRENDING_SUGGESTIONS_LOADER":
      return {
        ...state,
        trending_suggestions_loader: action.value,
      };
    case "SET_SELECTED_CHAT_DATA":
      return {
        ...state,
        selected_chat_data: action.value,
      };
    case "SET_BRAND_CHANGED":
      return {
        ...state,
        brand_changed: action.value,
      };
    case "SET_DURATION_CHANGED":
      return {
        ...state,
        duration_changed: action.value,
      };
    case "SET_OTP_STATUS_FLAG":
      return {
        ...state,
        otp_status_flag: action.value,
      };
    case "SET_SIGN_UP_LOADER":
      return {
        ...state,
        sign_up_loader: action.value,
      };
    case "SET_OTP_VALIDATE_LOADER":
      return {
        ...state,
        otp_validate_loader: action.value,
      };
    case "SET_USER_PROFILE_DETAILS":
      return {
        ...state,
        user_profile_details: action.value,
      };
    case "SET_USER_REGION_DETAILS":
      return {
        ...state,
        ChatWithData: {
          ...state.ChatWithData,
          user_profile_details: {
            ...state.ChatWithData.user_profile_details,
            profile_info: {
              ...state.ChatWithData.user_profile_details.profile_info,
              region: action.value,
            },
          },
        },
      };
    case "SET_USER_PROFILE_SAVE_LOADER":
      return {
        ...state,
        user_profile_save_loader: action.value,
      };
    case "SET_USER_PROFILE_MODAL_FLAG":
      return {
        ...state,
        user_profile_modal_flag: action.value,
      };
    case "SET_GET_VISITOR_ID_LOADER":
      return {
        ...state,
        get_visitor_id_loader: action.value,
      };
    case "SET_PAYMENT_PROCESS_LOADER":
      return {
        ...state,
        payment_process_loader: action.value,
      };
    case "SET_FOLLOW_UP_QUESTIONS_LIST":
      return {
        ...state,
        follow_up_questions_list: action.value,
      };
    case "SET_FOLLOW_UP_QUESTIONS_LOADER":
      return {
        ...state,
        follow_up_questions_loader: action.value,
      };
    case "SET_CREDITS_COUNT_LOADER":
      return {
        ...state,
        credits_count_loader: action.value,
      };
    case "SET_PLANS_LIST":
      return {
        ...state,
        plans_list: action.value,
      };
    case "SET_PLANS_LIST_LOADER":
      return {
        ...state,
        plans_list_loader: action.value,
      };
    case "SET_CANCEL_SUBSCRIPTION_LOADER":
      return {
        ...state,
        cancel_subscription_loader: action.value,
      };
    case "SET_DELETE_ACCOUNT_LOADER":
      return {
        ...state,
        delete_account_loader: action.value,
      };
    case "SET_SIGN_IN_THROUGH_FLAG":
      return {
        ...state,
        sign_in_through_flag: action.value,
      };
    case "SET_LANDING_PAGE_QUESTIONS_LIST":
      return {
        ...state,
        landing_page_questions_list: action.value,
      };
    case "SET_CREDIT_LIMIT_EXHAUSTED":
      return {
        ...state,
        credit_limit_exhausted: action.value,
      };
    case "SET_CONCURRENT_LIMIT_REACHED":
      return {
        ...state,
        concurrent_limit_reached: action.value,
      };
    case "SET_DELETE_ACCOUNT_REASON_LIST":
      return {
        ...state,
        delete_account_reason_list: action.value,
      };
    case "SET_AUTH_LOADER":
      return {
        ...state,
        auth_loader: action.value,
      };
    case "SET_NEGATIVE_FEEDBACK_REASON_LIST":
      return {
        ...state,
        negative_feedback_reason_list: action.value,
      };
    case "SET_GLOBAL_SEARCH_CHAT_LIST":
      return {
        ...state,
        global_search_chat_list: action.value,
      };
    case "SET_GLOBAL_SEARCH_CHAT_LOADER":
      return {
        ...state,
        global_search_chat_loader: action.value,
      };
    case "SET_SHARE_CHAT_ID":
      return {
        ...state,
        shareableLink: action.value,
      };
    case "SET_CHATS_STREAM_LOADER":
      return {
        ...state,
        chats_stream_loader: action.value,
      };
    case "SET_SIGN_UP_FAILED_FLAG":
      return {
        ...state,
        sign_up_failed_flag: action.value,
      };
    case "SET_CHARTS_ARTIFACT_LOADER":
      return {
        ...state,
        chart_artifact_loader: action.value,
      };
    case "SET_SHOW_BLURRED_BACKGROUND":
      return {
        ...state,
        show_blurred_background: action.value,
      };
    case "SET_PERSONA":
      return {
        ...state,
        persona: action.value,
      };
    
    // Streaming State Cases
    case "SET_REASONING_ACTIVE":
      return {
        ...state,
        chat_with_data_res: {
          ...state.chat_with_data_res,
          data: state.chat_with_data_res.data.map((chat) => {
            if (chat.query_id === action.payload.queryId) {
              return { ...chat, is_reasoning_active: action.payload.isActive };
            }
            return chat;
          }),
        },
      };
    
    case "SET_SSE_STREAMING":
      return {
        ...state,
        chat_with_data_res: {
          ...state.chat_with_data_res,
          data: state.chat_with_data_res.data.map((chat) => {
            if (chat.query_id === action.payload.queryId) {
              return { ...chat, is_sse_streaming: action.payload.isStreaming };
            }
            return chat;
          }),
        },
      };
    
    case "SET_FINAL_METADATA_RECEIVED":
      return {
        ...state,
        chat_with_data_res: {
          ...state.chat_with_data_res,
          data: state.chat_with_data_res.data.map((chat) => {
            if (chat.query_id === action.payload.queryId) {
              return { ...chat, has_final_metadata: action.payload.hasMetadata };
            }
            return chat;
          }),
        },
      };
    
    case "SET_SHOULD_COLLAPSE_REASONING":
      return {
        ...state,
        chat_with_data_res: {
          ...state.chat_with_data_res,
          data: state.chat_with_data_res.data.map((chat) => {
            if (chat.query_id === action.payload.queryId) {
              return { ...chat, should_collapse_reasoning: action.payload.shouldCollapse };
            }
            return chat;
          }),
        },
      };
    
    case "RESET_STREAMING_STATES":
      return {
        ...state,
        chat_with_data_res: {
          ...state.chat_with_data_res,
          data: state.chat_with_data_res.data.map((chat) => {
            if (chat.query_id === action.payload.queryId) {
              return {
                ...chat,
                is_reasoning_active: false,
                is_sse_streaming: false,
                has_final_metadata: false,
                should_collapse_reasoning: false,
                is_streaming: false,
                has_content_started: false,
                content_segments: [],
              };
            }
            return chat;
          }),
        },
      };

    case "SET_CONTENT_STARTED":
      return {
        ...state,
        chat_with_data_res: {
          ...state.chat_with_data_res,
          data: state.chat_with_data_res.data.map((chat) => {
            if (chat.query_id === action.payload.queryId) {
              return { ...chat, has_content_started: action.payload.hasStarted };
            }
            return chat;
          }),
        },
      };

    default:
      return state;
  }
};

export default ChatWithData;
